<template>
  <div class="promotion-container">
    <BlockHead @leaveRequest="leaveRequest" id="head" />
    <BlockInfo @leaveRequest="leaveRequest" id="info" />
    <BlockAdditionalServices @leaveRequest="leaveRequest" id="services" />
    <BlockSale @leaveRequest="leaveRequest" id="sale" />
    <BlockTrust id="trust" />
    <BlockActionTime @leaveRequest="leaveRequest" id="action-time" />

    <bimPopup title="" v-model="popup.show" width="350px" class="promotion-popup__wrapper">
      <SendRequest
        class="promotion-popup__content"
        :form_type="2"
        :additionalInfo="popup.data"
        :user_info="user_info"
        @close="popup.show = false"
      />
    </bimPopup>
  </div>
</template>

<script>
import bimPopup from "@bimlib/components/bimPopup";

import BlockActionTime from "./components/BlockActionTime";
import BlockAdditionalServices from "./components/BlockAdditionalServices";
import BlockHead from "./components/BlockHead";
import BlockInfo from "./components/BlockInfo";
import BlockSale from "./components/BlockSale";
import BlockTrust from "./components/BlockTrust"

import SendRequest from "@/pages/forms/Send_request";
export default {
  name: "landing-promotion",
  components: {
    bimPopup,
    BlockActionTime,
    BlockAdditionalServices,
    BlockHead,
    BlockInfo,
    BlockSale,
    BlockTrust,
    SendRequest,
  },

  props: {
    user_info: Object,
  },

  data() {
    return {
      popup: {
        show: false,
        data: ""
      },
    }
  },

  provide() {
    return {
      imgPath: '/dist/assets/front_white/img/landing_promotion'
    }
  },

  methods: {
    leaveRequest(msg) {
      this.popup.data = msg
      this.popup.show = true
    }
  }
}
</script>

<style scoped>
.promotion-popup__content {
  width: 100%;
}
.promotion-popup__wrapper ::v-deep .modal-content {
  width: 100%;
}
</style>
